import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import mixitup from 'mixitup';
import mixitupPagination from '../../../libs/mix-it-up-pagination/mixitup-pagination.min.js';

mixitup.use(mixitupPagination);

@Component({ className: 'js-filter' })
export class FilterComponent {
	private mixer: any;
	private targetSelector: string;

	constructor(private element: HTMLElement) {
		this.targetSelector = '.js-filter-item';

		this.mixer = mixitup(this.element, {
			selectors: {
				target: this.targetSelector,
				control: '.js-filter-control',
				pageList: '.js-filter-page-list'
			},
			animation: {
				enable: false
			},
			load: {
				filter: this.getSelectorFromHash()
			},
			callbacks: {
				onMixEnd: (e: any) => {
					this.setHash(e);
				}
			}
		});

		window.addEventListener('hashchange', () => {
			const selector = this.getSelectorFromHash();
			if (selector === this.mixer.getState().activeFilter.selector) return;
			this.mixer.filter(selector);
		});

		if (window.location.hash) {
			const target = document.querySelector('#scroll-target') ?? this.element;
			window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 125, behavior: 'smooth' });
		}
	}

	getSelectorFromHash() {
		const hash = window.location.hash.replace(/^#/g, '');
		const selector = hash ? '.' + hash : this.targetSelector;
		return selector;
	}

	setHash(state: any) {
		const selector = state.activeFilter.selector;
		const newHash = '#' + selector.replace(/^\./g, '');
		if (selector === this.targetSelector && window.location.hash) {
			history.pushState(null, document.title, window.location.pathname);
		} else if (newHash !== window.location.hash && selector !== this.targetSelector) {
			history.pushState(null, document.title, window.location.pathname + newHash);
		}
	}
}
